var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLink(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-8234.91,-823.94)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "write-grey",
    transform: "matrix(0.145417,0,0,0.186342,7831.39,764.899)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 2774.96,
    y: 316.846,
    width: 220.057,
    height: 171.727,
    style: {
      fill: "none"
    }
  }), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.18293,0,0,1.18293,-539.625,-71.7145)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(6.87679,0,-8.88178e-16,5.36648,-53832.4,-3716.57)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8247.85,771.621L8244.9,774.566C8244.36,775.109 8243.62,775.415 8242.86,775.415C8241.27,775.415 8239.96,774.107 8239.96,772.518C8239.96,771.75 8240.26,771.013 8240.81,770.47L8245.27,766.009C8245.81,765.466 8246.55,765.161 8247.32,765.161C8248.58,765.161 8249.67,765.993 8250.06,767.135C8250.16,767.429 8250.48,767.586 8250.78,767.486C8251.07,767.385 8251.23,767.065 8251.13,766.771C8250.59,765.185 8249.08,764.034 8247.32,764.034C8246.25,764.034 8245.23,764.458 8244.47,765.212L8240.01,769.673C8239.26,770.427 8238.83,771.451 8238.83,772.518C8238.83,774.725 8240.65,776.542 8242.86,776.542C8243.92,776.542 8244.95,776.117 8245.7,775.363L8248.65,772.418C8248.87,772.198 8248.87,771.841 8248.65,771.621C8248.43,771.401 8248.07,771.401 8247.85,771.621Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-6.87679,6.57204e-16,4.60142e-17,-5.36648,59622.5,4518.69)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8247.85,771.621L8244.9,774.566C8244.36,775.109 8243.62,775.415 8242.86,775.415C8241.27,775.415 8239.96,774.107 8239.96,772.518C8239.96,771.75 8240.26,771.013 8240.81,770.47L8245.27,766.009C8245.81,765.466 8246.55,765.161 8247.32,765.161C8248.58,765.161 8249.67,765.993 8250.06,767.135C8250.16,767.429 8250.48,767.586 8250.78,767.486C8251.07,767.385 8251.23,767.065 8251.13,766.771C8250.59,765.185 8249.08,764.034 8247.32,764.034C8246.25,764.034 8245.23,764.458 8244.47,765.212L8240.01,769.673C8239.26,770.427 8238.83,771.451 8238.83,772.518C8238.83,774.725 8240.65,776.542 8242.86,776.542C8243.92,776.542 8244.95,776.117 8245.7,775.363L8248.65,772.418C8248.87,772.198 8248.87,771.841 8248.65,771.621C8248.43,771.401 8248.07,771.401 8247.85,771.621Z"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLink);
export default __webpack_public_path__ + "static/media/link.b61904f5836827a6eab5d1346588d9e4.svg";
export { ForwardRef as ReactComponent };